export default __webpack_public_path__ + "static/media/waterfalls1.ae044ea3.webp";